import { ENDPOINTS } from '../../apis/endpoints'
import { apiSlice } from '../../app/api/apiSlice'
import { searchFulfilled, searchPending } from './searchSlice'

export const searchApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    searchEmployee: builder.query({
      query: ({ searchTerm, selectedFilter, page }) =>
        `${ENDPOINTS.EMPLOYEE.EMPLOYEE_SEARCH}?searchTerm=${searchTerm}&selectedFilter=${selectedFilter}&page=${page}`,
      async onQueryStarted (args, { dispatch, queryFulfilled }) {
        dispatch(searchPending)
        //   const { data } = await queryFulfilled
        //   dispatch(searchFulfilled(data))
      },
    }),
  }),
})

export const { useLazySearchEmployeeQuery } = searchApiSlice
